module.exports = __webpack_public_path__ + "static/media/coach-hero.1f73d842.jpg";